/**
 * @generated SignedSource<<293162a712c2f07f97babf088d42203c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClaimAvatarQuery$variables = {
  identifier: string;
};
export type ClaimAvatarQuery$data = {
  readonly profile: {
    readonly avatar: {
      readonly blurhash: string | null | undefined;
      readonly icon: string;
      readonly small: string;
    } | null | undefined;
    readonly handle: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AvatarFragment">;
  } | null | undefined;
};
export type ClaimAvatarQuery = {
  response: ClaimAvatarQuery$data;
  variables: ClaimAvatarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "handle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMediaImage",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "small",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurhash",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClaimAvatarQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AvatarFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClaimAvatarQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isIGraphQLProfile"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7b0a7667766c8c652b548a8e8d6fd1e4",
    "id": null,
    "metadata": {},
    "name": "ClaimAvatarQuery",
    "operationKind": "query",
    "text": "query ClaimAvatarQuery(\n  $identifier: String!\n) {\n  profile(identifier: $identifier) {\n    __typename\n    id\n    handle\n    avatar {\n      icon\n      small\n      blurhash\n    }\n    ...AvatarFragment\n  }\n}\n\nfragment AvatarFragment on IGraphQLProfile {\n  __isIGraphQLProfile: __typename\n  handle\n  avatar {\n    icon\n    small\n    blurhash\n  }\n}\n"
  }
};
})();

(node as any).hash = "431977f060fcafebe0ebaf152abd3d05";

export default node;
